import UIList from 'UIComponents/list/UIList';
import UISelectableButton from 'UIComponents/button/UISelectableButton';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { GRID_BREAKPOINT_MEDIUM } from 'HubStyleTokens/sizes';
import UsageTracker from '../../utils/UsageTracker';
import { HUBSPOT_SOFTWARE_INDEX, useCurrentLearningInterest, useWizardCategoriesMap } from '../../features/wizard';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const ToolsUIList = styled(UIList).withConfig({
  displayName: "WizardTools__ToolsUIList",
  componentId: "sc-1a65pt-0"
})(["width:100%;@media (min-width:", "){max-width:400px;}"], GRID_BREAKPOINT_MEDIUM);
const WizardTools = ({
  onOptionSelect
}) => {
  const {
    selectedToolsGroup
  } = useCurrentLearningInterest();
  const {
    wizardCategoryMap,
    isLoading
  } = useWizardCategoriesMap();
  const trackToolGroupClick = toolsGroup => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-tools-group',
      categoryClicked: toolsGroup
    });
  };
  const trackToolClick = tool => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-tool',
      categoryClicked: tool
    });
  };
  const selectTool = tool => {
    onOptionSelect(tool);
  };
  const selectToolGroup = group => {
    onOptionSelect(group);
  };
  const renderToolList = () => {
    const toolsMap = wizardCategoryMap[HUBSPOT_SOFTWARE_INDEX];
    return /*#__PURE__*/_jsx(ToolsUIList, {
      childClassName: "m-bottom-4",
      children: !selectedToolsGroup ? Object.keys(toolsMap).map(toolGroup => /*#__PURE__*/_jsx(UISelectableButton, {
        block: true,
        onClick: () => trackToolGroupClick(toolGroup),
        onSelectedChange: () => {
          selectToolGroup(toolGroup);
        },
        selected: false,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.filtersGroups.${toolGroup}`
        })
      }, toolGroup)) : Object.values(toolsMap[selectedToolsGroup]).map(tool => /*#__PURE__*/_jsx(UISelectableButton, {
        block: true,
        onClick: () => trackToolClick(tool),
        onSelectedChange: () => {
          selectTool(tool);
        },
        selected: false,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.topFilters.tools.${tool}`
        })
      }, tool))
    });
  };
  return !isLoading ? renderToolList() : /*#__PURE__*/_jsx(UILoadingSpinner, {
    size: 'sm'
  });
};
export default WizardTools;